import { Component, HostBinding, Input, OnInit, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { hexToRgb, rgbToHsv, hsvToHex } from './color-utils';

@Component({
  selector: 'suka-color-picker',
  template: `
  <div class="input-wrapper" *ngIf="showInput">
    <input
      [ngModel]="color"
      (ngModelChange)="onColorChange($event)"
    />
    <div
      class="color-div"
      [ngStyle]="{'background-color': color || 'white'}"
    ></div>
  </div>
  <div class="color-wrapper">
    <suka-color-palette
      [hue]="hue"
      [color]="color"
      (colorChange)="onColorSelect($event)"
    ></suka-color-palette>
    <suka-color-slider
      [(hue)]="hue"
    ></suka-color-slider>
  </div>
  `
})
export class ColorPicker implements OnInit {
  @HostBinding('class.color-picker') baseClass = true;

  @Input() color: string;
  @Output() colorChange = new EventEmitter();
  @Input() showInput = true;

  public hue: string;
  public globalHue: string;

  ngOnInit() {
    const rgbColor = hexToRgb(this.color);
    if (rgbColor) {
      const hsv = rgbToHsv(rgbColor.r, rgbColor.g, rgbColor.b);
      this.hue = hsvToHex(hsv.h, 100, 100);
    }
  }

  onColorChange(event) {
    const rgbColor = hexToRgb(event);

    if (rgbColor) {
      const hsv = rgbToHsv(rgbColor.r, rgbColor.g, rgbColor.b);
      this.hue = hsvToHex(hsv.h, 100, 100);
      this.color = event;
    }

    this.emitColorChange(this.color);
  }

  onColorSelect(event) {
    this.color = event;
    this.emitColorChange(this.color);
  }

  private emitColorChange(color) {
    this.colorChange.emit(color);
  }
}
